
    import './styles.scoped.css';
    export default {
  "content-enter": "awsui_content-enter_gwq0h_1lzps_97",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_gwq0h_1lzps_1",
  "trigger-expanded": "awsui_trigger-expanded_gwq0h_1lzps_119",
  "icon": "awsui_icon_gwq0h_1lzps_133",
  "root": "awsui_root_gwq0h_1lzps_151",
  "expand-button": "awsui_expand-button_gwq0h_1lzps_168",
  "expanded": "awsui_expanded_gwq0h_1lzps_175",
  "icon-container": "awsui_icon-container_gwq0h_1lzps_179",
  "icon-container-container": "awsui_icon-container-container_gwq0h_1lzps_184",
  "wrapper": "awsui_wrapper_gwq0h_1lzps_188",
  "wrapper-default": "awsui_wrapper-default_gwq0h_1lzps_195",
  "wrapper-footer": "awsui_wrapper-footer_gwq0h_1lzps_198",
  "wrapper-navigation": "awsui_wrapper-navigation_gwq0h_1lzps_204",
  "wrapper-container": "awsui_wrapper-container_gwq0h_1lzps_207",
  "wrapper-expanded": "awsui_wrapper-expanded_gwq0h_1lzps_224",
  "header": "awsui_header_gwq0h_1lzps_228",
  "header-wrapper": "awsui_header-wrapper_gwq0h_1lzps_231",
  "header-deprecated": "awsui_header-deprecated_gwq0h_1lzps_231",
  "header-button": "awsui_header-button_gwq0h_1lzps_241",
  "header-container-button": "awsui_header-container-button_gwq0h_1lzps_245",
  "header-container": "awsui_header-container_gwq0h_1lzps_245",
  "header-navigation": "awsui_header-navigation_gwq0h_1lzps_269",
  "content": "awsui_content_gwq0h_1lzps_97",
  "content-default": "awsui_content-default_gwq0h_1lzps_305",
  "content-footer": "awsui_content-footer_gwq0h_1lzps_308",
  "content-expanded": "awsui_content-expanded_gwq0h_1lzps_311",
  "focusable": "awsui_focusable_gwq0h_1lzps_315",
  "click-target": "awsui_click-target_gwq0h_1lzps_326",
  "description-default": "awsui_description-default_gwq0h_1lzps_333",
  "description-footer": "awsui_description-footer_gwq0h_1lzps_334",
  "description-container": "awsui_description-container_gwq0h_1lzps_338"
};
  